<template>
  <footer class="p-3 text-sm text-gray-600 dark:text-gray-400">
    © FoxSolution SRL
  </footer>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FooterComponent'
});
</script>
